import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseDialogIcon from '../../../assets/image/Mask.png';
import DialogComponent from "../../HelperComponents/DialogComponent/DialogComponent";
import CreateRefundByOrderNumber from "./CreateRefundByOrderNumber";
import CreateRefundByAccepted from "./CreateRefundByAccepted";
import CreateRefundByResidue from "./CreateRefundByResidue";

const classes = {
    root: 'default_dialog_root transactions-dialog',
    paper: 'paper_custom_dialog'
};

const TABS = [
    { key: 'order', label: "По номеру заказа", component: CreateRefundByOrderNumber },
    { key: 'residue', label: "По номеру выдачи", component: CreateRefundByResidue },
    { key: 'accepted', label: "По номеру приема", component: CreateRefundByAccepted },
];

export default function CreateRefundRequestDialog({ open, toggleDialog, availableTabs, ...props }) {
    const tabs = React.useMemo(
        () => (availableTabs ? TABS.filter(t => availableTabs.includes(t.key)) : TABS),
        [availableTabs]
    );
    const [tab, setTab] = React.useState(0);

    React.useEffect(() => {
        setTab(0);
    }, [tabs]);

    if (tabs.length === 0) return null;

    const ActiveComponent = tabs[tab].component;

    return (
        <DialogComponent open={open} onClose={toggleDialog} classes={classes}>
            <div className="title-dialog">Создать заявку на возврат</div>
            <div className="tab_custom">
                {tabs.map((tabItem, index) => (
                    <button key={tabItem.key} className={tab === index ? 'active' : ''} onClick={() => setTab(index)}>
                        {tabItem.label}
                    </button>
                ))}
            </div>
            <ActiveComponent toggleDialog={toggleDialog} {...props} />
            <IconButton classes={{ root: "dialog_close_button" }} onClick={toggleDialog}>
                <img src={CloseDialogIcon} alt="close" />
            </IconButton>
        </DialogComponent>
    );
}
